import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { GENDER } from 'domains/exclusive-seller/constants/exclusive-seller-constants'

/**
 * To give nice look in gender type by given seller type of the seller
 * @param {string} gender gender type. available value
 * - `female`
 * - `male`
 */
const ExclusiveSellerGenderBadge = ({ gender }) => {

  const colorMap = {
    [GENDER.FEMALE] : 'primary',
    [GENDER.MALE]   : 'warning'
  }

  const color = colorMap[gender] || 'default'

  return <StatusBadge color={ color } label={ gender } />
}

ExclusiveSellerGenderBadge.propTypes = {
  gender: PropTypes.string
}

export default ExclusiveSellerGenderBadge
